import Pagination from 'main/components/tables/interactive/components/pagination/Pagination';

export default Pagination;
